const FRONT_RELEASE = process.env.FRONT_RELEASE

export default {
    env: 'staging',
    api_url: 'https://app.eficienciafiscal.tk/api',
    graphql_url: 'https://app.eficienciafiscal.tk/graphql',
    socket_url: 'wss://app.eficienciafiscal.tk/socket',
    legacy_url: 'https://app.eficienciafiscal.tk',
    external_url: 'https://app.eficienciafiscal.tk/externo',
    sentry: {
        dsn: "https://4a70ef6ada514f71a28604bbd9857f3f@sentry.eficienciafiscal.com.br/8",
        environment: "staging",
        release: FRONT_RELEASE
    }
}
